import React, { useState, useEffect } from "react";
import { useCfmContext } from "../../../Context/CfmContext";
import InputTextArea from "../../Inputs/InputTextArea";
import "../../../../../../css/CashflowModeller2/Tabs/Notes.css"; 
import { useClientMeta } from "../../../Hooks/UseClientMeta";
import SaveButton from "../../Buttons/SaveButton"; 

/**
 * Notes component for displaying and editing notes associated with client details.
 *
 * - Displays a text area for notes if at least one client detail exists.
 * - Shows a "Save" button for users with own client access (`isOwnClient`).
 * - Handles updating notes in local state and dispatches updates to context.
 * - If no client details are present, prompts the user to add at least one client.
 *
 * @component
 * @returns {JSX.Element} The rendered Notes component.
 */
const Notes = () => {
  const { state, dispatch } = useCfmContext();
  const { isOwnClient } = useClientMeta();
  const allNames = (state.details || [])
    .map((d) => d.name)
    .filter(Boolean)
    .join(" & ");
  const [notes, setNotes] = useState("");

  useEffect(() => {
    setNotes(state.notes || "");
  }, [state.notes]);

  /**
   * Updates the notes state and dispatches an action to update notes in the global store.
   *
   * @param {string} newNotes - The updated notes content to be set and dispatched.
   */
  const handleUpdate = (newNotes) => {
    setNotes(newNotes);
    dispatch({ type: "UPDATE_NOTES", payload: newNotes });
  };

  return state.details?.length > 0 ? (
    <div className="notes-container">
      <div className="notes-container-header">
        <div className="Label">
          {state.details?.length === 0 ? "Notes" : `Notes for ${allNames}`}
        </div>
        {/* {isOwnClient && (
          <div
            className="Content-Small"
            style={{cursor: "pointer"}}
            onClick={() => dispatch({ type: "UPDATE_NOTES", payload: notes })}
            isDisabled={state.details?.length === 0 || !notes.trim()}
          >
            </div>
          <SaveButton
            buttonText="Save"
            onClick={() => handleUpdate(notes)}
            isDisabled={state.details?.length === 0 || !notes.trim()}
            className="save-button"
            isActive={true}
          >
            Save
          </SaveButton>
        )} */}
      </div>

      <InputTextArea
        // label={state.details?.length === 0 ? "Notes" : `Notes for ${allNames}`}
        label=""
        value={notes}
        onChange={handleUpdate}
        isDisabled={state.details?.length === 0}
        placeholder=""
        type="text"
      />
    </div>
  ) : (
    <div className="Content-Small">
      <div className="no-details-message">
        Please add at least one client to enter notes.
      </div>
    </div>
  );
};
export default Notes;
